import {nl} from './nl';
import {isValidElement, ReactElement} from 'react';

const defaultLanguage = nl;
type TransType = {
    [key: string]: string | ReactElement | ((args?: Record<string, string>) => string | ReactElement) | TransType;
};

function getTranslations(locale: string): TransType {
    switch (locale) {
        case 'en-GB':
        case 'en-US':
            return nl; // Temp till everything is translated
        case 'nl-NL':
            return nl;
        default:
            return defaultLanguage;
    }
}

export function __(key: string, args?: Record<string, string>): string | ReactElement {
    const locale = window.navigator.language;
    const languageFile = getTranslations(locale);
    let translation = getNestedTranslation(key, languageFile, args);

    if (translation === null) {
        console.warn(`No translation found for key: "${key}" for language "${locale}". Try using fallback language.`);
        translation = getNestedTranslation(key, defaultLanguage, args);
        if (translation === null) {
            console.warn(`No translation found for key: "${key}" in fallback language.`);
        }
    }

    if (translation !== null) {
        return translation;
    }

    return key;
}

export function transString(key: string, args?: Record<string, string>): string {
    const translation = __(key, args);
    if (typeof translation === 'string') {
        return translation;
    }
    return key;
}

function getNestedTranslation(
    key: string,
    translations: TransType,
    args?: Record<string, string>,
): string | ReactElement | null {
    const splittedKey = key.split('.');

    let cursor = splittedKey.shift();
    let translation = translations;
    while (cursor != null && translation != null) {
        const transValue = translation[cursor];

        if (isValidElement(transValue)) {
            return transValue;
        }
        if (typeof transValue === 'string') {
            return transValue;
        }
        if (typeof transValue === 'function') {
            return transValue(args);
        }

        translation = transValue as TransType;
        cursor = splittedKey.shift();
    }

    return null;
}
